import { requestWithToken as request } from "./api";

export const getCarteraAnalista = () => request.get(`/analyst_view/get_all/`);

export function getUploadedFiles(company_id, file_id, page) {
    const result = request.get(
        `/analyst_view/${company_id}/all_uploads/?page=${page}&file_id=${file_id}`
    );
    return result;
}

export const allAnalysts = () => request.get(`/analyst_view/analysts_list/`);
export const allCompanies = () => request.get(`/analyst_view/companies_list/`);
export function saveCartera(
    company_id,
    old_analists,
    new_analists,
    deleted_analists
) {
    const param = {
        old_analists: old_analists,
        new_analists: new_analists,
        deleted_analists: deleted_analists,
    };
    return request.post(`/analyst_view/${company_id}/save_cartera/`, param);
}

export const getDetalleCompania = (id, full) =>
    request.get(`/analyst_view/${id}/complementary_data/?full=${full}`);

export const getFileData = (id) =>
    request.get(`/analyst_view/${id}/file_data/`);

export const getAccountPlanForCompany = (id) =>
    request.get(
        `/classification_admin_view/${id}/get_account_plan_for_company/`
    );

export const getCategories = () =>
    request.post(`/classification_user_view/categories/`);

export const getSpecificCounterparts = (id, list, document_type) => {
    const data = {
        'company_involved': id,
        'list_ids': list,
        'document_type': document_type,
    };
    return request.post(`classification_user_view/specific_counterparts/`, data);
}
export const getDocumentsInvolved = (companies_involved, document_type) => {
    const data = {
        'companies_involved': companies_involved,
        'document_type': document_type,
    }
    return request.post(
        `/classification_user_view/documents_involved/`, data
    );
}

export const getPaginatedCounterparts = (period_months, from, to) => {
    const data = {
        'period_months': period_months,
        'from': from,
        'to': to,
    }
    return request.post(`/classification_user_view/counterparts/`, data);
}

export const get_prorates_x_company_involved = (
    company_involved_id,
    document_id_selected,
    document_type,
) => {
    const data = {
        'company_involved_id': company_involved_id,
        'document_id_selected': document_id_selected,
        'document_type': document_type,
    }

    return request.post(
        `/classification_user_view/get_prorates_x_company_involved/`, data
    );
}

export const save_analysts_per_company = (company_id, data) =>
    request.post(
        `/analyst_view/${company_id}/save_analysts_per_company/`, data
    );

export const save_companies_analyst = (user_id, data) =>
    request.post(
        `/analyst_view/${user_id}/save_companies_analyst/`, data
    );
    
export const companies_per_user = (user_id) =>
    request.get(
        `/analyst_view/${user_id}/companies_per_user`
    );
    
export const users_of_company = (company_id) =>
    request.get(
        `/analyst_view/${company_id}/users_of_company`
    );
    
export const get_prorate_x_attribute_by_company_involved = (
    company_involved_id,
    category_type,
    documentIdSelected,
    document_type,
) =>
    request.get(
        `/classification_user_view/get_prorate_x_attribute_by_company_involved/?company_involved_id=${company_involved_id}&category_type=${category_type}&document_id_selected=${documentIdSelected}&document_type=${document_type}`
    );

export const save_prorate_by_company_involved = (data) =>
    request.post(
        `/classification_user_view/save_prorate_by_company_involved/`,
        data
    );

export const delete_prorate_by_company_involved = (data) =>
    request.post(
        `/classification_user_view/delete_prorate_by_company_involved/`,
        data
    );

export const createAccount = (companyId, level_2_id, cuenta_name) => {
    const params = { level_2_id: level_2_id, cuenta_name: cuenta_name };
    return request.post(
        `/classification_admin_view/${companyId}/create_account_for_company/`,
        params
    );
};

export const saveAccountPlans = (id, checked, already_saved) => {
    const params = { raw_account_plans: checked, already_saved: already_saved };
    return request.post(
        `/classification_admin_view/${id}/save_account_plans_for_company/`,
        params
    );
};

export const getFirstRows = (id) =>
    request.get(`/analyst_view/${id}/load_first_rows/`);

export const grabarConfiguracion = (id, params = {}) => {
    return request.post(`/analyst_view/${id}/save_configuration/`, params);
};

export const toggleFile = (id, toggle, company) => {
    const params = { toggle: toggle, company: company };
    return request.post(`/analyst_view/${id}/toggle_file/`, params);
};

export const sendEmailDocs = (company, userid, which) => {
    const params = { userid: userid, which: which };
    return request.post(`/analyst_view/${company}/send_email_docs/`, params);
};

export const updateGeneralBookSheetId = (id_drive_file, company_id) =>
    request.post("/analyst_view/update_general_book_drive_id/", {
        id_drive_file,
        company_id,
    });

export const getUsersByCompany = (company_id) =>
    request.get(`/analyst_view/${company_id}/users_by_company/`, {});

export const updateUserOperations = (company_id, userOps) =>
    request.post(
        `/analyst_view/${company_id}/update_user_operations/`,
        userOps
    );

export const saveTipoNegocio = (company_id, checked) =>
    request.post("/analyst_view/save_business_type/", { company_id, checked });

export const getAttributes = (company_id) =>
    request.get(`/attributes/?company_id=${company_id}`);

export const addAttributes = (attribute) =>
    request.post(`/attributes/`, attribute);

export const deleteAttributes = (attribute, company_id) =>
    request.delete(`/attributes/${attribute.id}`, { data: { company_id } });
